/* Pawvela storefront behaviour. Uses Shopify's cart (Shopify.actions.updateCart → theme cart drawer),
   falls back to /cart/add.js. Never selects an option on the shopper's behalf. */
(function () {
  'use strict';
  if (window.PV) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PV = (window.PV = {});
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  PV.money = money;

  /* ---------- toast ---------- */
  var toastEl, tt;
  PV.toast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(tt);
    tt = setTimeout(function () { toastEl.classList.remove('is-show'); }, 4000);
  };

  /* ---------- cart ---------- */
  function addViaAjax(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: Number(i.id), quantity: i.quantity }; }) })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'That item could not be added.');
        return { viaAjax: true };
      });
    });
  }
  function addViaActions(items) {
    return Shopify.actions.updateCart({
      lines: items.map(function (i) { return { merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity }; })
    }, { event: { context: 'product' } }).then(function (res) {
      if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      return res;
    });
  }
  PV.add = function (btn, items, label) {
    if (btn && btn.getAttribute('aria-busy') === 'true') return Promise.resolve(false);
    var html = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '<span class="pv-spin" aria-hidden="true"></span> Adding…'; }
    var useActions = window.Shopify && Shopify.actions && Shopify.actions.updateCart;
    var p = useActions ? addViaActions(items) : addViaAjax(items);
    return p.then(function (res) {
      if (btn) { btn.removeAttribute('aria-busy'); btn.innerHTML = html; }
      document.documentElement.classList.remove('pv-recs-off');
      try { sessionStorage.removeItem('pv_recs_off'); } catch (e) {}
      if (res && res.viaAjax) { window.location.href = root + 'cart'; return true; }
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      setTimeout(function () {
        if (drawer && !drawer.hasAttribute('open') && Shopify.actions.openCart) Shopify.actions.openCart();
      }, 450);
      if (!drawer) PV.toast((label || 'Item') + ' added to your cart');
      return true;
    }).catch(function (err) {
      if (btn) { btn.removeAttribute('aria-busy'); btn.innerHTML = html; }
      PV.toast('Not added: ' + (err && err.message ? err.message : 'please try again.'));
      return false;
    });
  };

  /* ---------- product data + variant resolution ---------- */
  var products = {};
  PV.product = function (handle) {
    if (products[handle]) return products[handle];
    var el = document.querySelector('script[data-pv-product="' + handle + '"]');
    if (!el) return null;
    try { products[handle] = JSON.parse(el.textContent); } catch (e) { return null; }
    return products[handle];
  };
  /* choice: array of selected values per option (null where not chosen). Single-value options count as chosen. */
  PV.resolve = function (p, choice) {
    var full = p.options.map(function (o, i) { return o.values.length === 1 ? o.values[0] : choice[i]; });
    if (full.some(function (v) { return v == null; })) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.options.every(function (x, j) { return x === full[j]; })) return v;
    }
    return null;
  };
  PV.minPrice = function (p) { return Math.min.apply(null, p.variants.map(function (v) { return v.price; })); };
  PV.hasRange = function (p) { var a = p.variants.map(function (v) { return v.price; }); return Math.min.apply(null, a) !== Math.max.apply(null, a); };

  /* ---------- option groups (radio segments) ---------- */
  function optionGroupHTML(p, idx, name, note) {
    var o = p.options[idx];
    var count = o.values.length;
    return '<fieldset class="pv-sizer" data-opt="' + idx + '"><legend class="pv-sizer__lab"><span style="font-weight:700;color:var(--pv-navy)">' + o.name +
      ' <span data-chosen></span></span>' + (note || '') + '</legend><div class="pv-seg" style="--n:' + Math.min(count, 4) + '">' +
      o.values.map(function (val, k) {
        var any = p.variants.some(function (v) { return v.options[idx] === val && v.available; });
        var sub = o.hints && o.hints[val] ? o.hints[val] : '';
        return '<div class="pv-seg__o"><input type="radio" name="' + name + '" id="' + name + k + '" value="' + escAttr(val) + '"' + (any ? '' : ' disabled') + '><label for="' + name + k + '"><b>' + esc(val) + '</b>' + (any ? (sub ? '<small>' + esc(sub) + '</small>' : '') : '<small>Sold out</small>') + '</label></div>';
      }).join('') + '</div><p class="pv-err" role="alert"></p></fieldset>';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function escAttr(s) { return esc(s); }
  PV.esc = esc;

  /* A "picker" binds option radios to a product. Used by the spotlight, PDP and the quick sheet. */
  PV.picker = function (container, p, name, onChange) {
    var multi = p.options.map(function (o, i) { return o.values.length > 1 ? i : -1; }).filter(function (i) { return i > -1; });
    var choice = p.options.map(function () { return null; });
    container.innerHTML = multi.map(function (i) { return optionGroupHTML(p, i, name + i, container.dataset.note && i === multi[0] ? container.dataset.note : ''); }).join('');
    $$('input[type=radio]', container).forEach(function (r) {
      r.addEventListener('change', function () {
        var fs = r.closest('fieldset'), i = +fs.dataset.opt;
        choice[i] = r.value;
        $('[data-chosen]', fs).textContent = '· ' + r.value;
        fs.querySelector('.pv-seg').classList.remove('is-invalid');
        $('.pv-err', fs).textContent = '';
        if (onChange) onChange(PV.resolve(p, choice), choice);
      });
    });
    return {
      variant: function () { return PV.resolve(p, choice); },
      set: function (i, val) { var r = $$('input', container).filter(function (x) { return +x.closest('fieldset').dataset.opt === i && x.value === val; })[0]; if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change')); } },
      complain: function () {
        var first = null;
        multi.forEach(function (i) {
          if (choice[i] == null) {
            var fs = container.querySelector('fieldset[data-opt="' + i + '"]');
            fs.querySelector('.pv-seg').classList.add('is-invalid');
            $('.pv-err', fs).textContent = 'Choose a ' + p.options[i].name.toLowerCase() + ' to continue.';
            if (!first) first = fs;
          }
        });
        if (first) {
          first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          var f = $('input:not(:disabled)', first); if (f) f.focus({ preventScroll: true });
        }
      },
      multi: multi.length
    };
  };

  /* ---------- quick option sheet ---------- */
  var sheet;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'pv pv-dlg';
    sheet.setAttribute('aria-labelledby', 'pv-sheet-h');
    sheet.innerHTML = '<div class="pv-dlg__h"><h2 id="pv-sheet-h"></h2><button class="pv-x" type="button" data-pv-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="pv-dlg__b" id="pv-sheet-b"></div>';
    document.body.appendChild(sheet);
    wireDialog(sheet);
    return sheet;
  }
  function wireDialog(d) {
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-pv-close]')) d.close(); });
  }
  PV.wireDialog = wireDialog;
  PV.openSheet = function (handle, opts) {
    opts = opts || {};
    var p = PV.product(handle); if (!p) return;
    var d = ensureSheet(), b = $('#pv-sheet-b', d);
    $('#pv-sheet-h', d).textContent = p.title;
    b.innerHTML = '<div class="pv-sheetprod"><img src="' + p.image + '" alt="" width="96" height="96"><div><p style="color:var(--pv-muted);font-size:15px">' + esc(p.line || '') + '</p><p style="margin-top:4px;font-weight:800;color:var(--pv-navy);font-size:18px" class="pv-tn" data-sp>' + (PV.hasRange(p) ? 'From ' : '') + money(PV.minPrice(p)) + '</p></div></div><div data-opts></div><button class="pv-btn pv-btn--buy pv-btn--block" type="button" data-add>Add to cart</button>' +
      (p.note ? '<p style="font-size:13px;color:var(--pv-muted)">' + esc(p.note) + '</p>' : '') +
      '<a class="pv-link" href="' + p.url + '" style="justify-self:start">See full details</a>';
    var pk = PV.picker($('[data-opts]', b), p, 'pvq', function (v) { if (v) $('[data-sp]', b).textContent = money(v.price); });
    if (opts.preset) opts.preset.forEach(function (v, i) { if (v != null) pk.set(i, v); });
    $('[data-add]', b).addEventListener('click', function () {
      var v = pk.variant();
      if (!v) { pk.complain(); return; }
      var btn = this;
      PV.add(btn, [{ id: v.id, quantity: opts.qty || 1 }], p.title).then(function (ok) { if (ok) d.close(); if (ok && opts.after) opts.after(v); });
    });
    d.showModal();
  };

  /* ---------- delivery estimate (business days) ---------- */
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  PV.delivery = function () {
    $$('[data-pv-deliv]').forEach(function (e) {
      var a = +e.dataset.min || 6, b = +e.dataset.max || 12;
      e.textContent = 'Estimated delivery ' + fmt(addBiz(new Date(), a)) + ' – ' + fmt(addBiz(new Date(), b));
    });
  };

  /* ---------- carrier size guide drawing ---------- */
  PV.drawCarrier = function (s) {
    var k = 5.6, base = 250, x1 = 46, x2 = 46 + 46 * k + 60, side = { w: s.L * k, h: s.H * k }, front = { w: s.W * k, h: s.H * k };
    function box(x, w, h, lab, door) {
      var y = base - h;
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="12" fill="#EAF1F7" stroke="#16365C" stroke-width="1.8"/><rect x="' + (x + w * (door ? .2 : .12)) + '" y="' + (y + h * .18) + '" width="' + (w * (door ? .6 : .76)) + '" height="' + (h * .66) + '" rx="8" fill="none" stroke="#16365C" stroke-opacity=".4" stroke-width="1.3" stroke-dasharray="3 4"/><line x1="' + x + '" y1="' + (base + 18) + '" x2="' + (x + w) + '" y2="' + (base + 18) + '" stroke="#16365C"/><line x1="' + x + '" y1="' + (base + 12) + '" x2="' + x + '" y2="' + (base + 24) + '" stroke="#D96A3E" stroke-width="2"/><line x1="' + (x + w) + '" y1="' + (base + 12) + '" x2="' + (x + w) + '" y2="' + (base + 24) + '" stroke="#D96A3E" stroke-width="2"/><text x="' + (x + w / 2) + '" y="' + (base + 42) + '" text-anchor="middle" font-family="Figtree,Arial,sans-serif" font-size="15" font-weight="700" fill="#16365C">' + lab + '</text>';
    }
    var hx = x1 - 18, y = base - side.h;
    return '<svg viewBox="0 0 640 300" role="img" aria-label="Side and front outline of the ' + s.o + ' carrier, drawn to scale: ' + s.L + ' by ' + s.W + ' by ' + s.H + ' cm">' + box(x1, side.w, side.h, s.L + ' cm long', false) + box(x2, front.w, front.h, s.W + ' cm wide', true) +
      '<line x1="' + hx + '" y1="' + y + '" x2="' + hx + '" y2="' + base + '" stroke="#16365C"/><line x1="' + (hx - 6) + '" y1="' + y + '" x2="' + (hx + 6) + '" y2="' + y + '" stroke="#D96A3E" stroke-width="2"/><line x1="' + (hx - 6) + '" y1="' + base + '" x2="' + (hx + 6) + '" y2="' + base + '" stroke="#D96A3E" stroke-width="2"/><text x="' + (hx - 9) + '" y="' + (y + side.h / 2) + '" text-anchor="middle" font-family="Figtree,Arial,sans-serif" font-size="15" font-weight="700" fill="#16365C" transform="rotate(-90 ' + (hx - 9) + ' ' + (y + side.h / 2) + ')">' + s.H + ' cm high</text><text x="' + x1 + '" y="22" font-family="Figtree,Arial,sans-serif" font-size="14" fill="#566578">Side</text><text x="' + x2 + '" y="22" font-family="Figtree,Arial,sans-serif" font-size="14" fill="#566578">Front</text></svg>';
  };
  PV.CARRIER_SIZES = [
    { o: 'Small', L: 40, W: 25, H: 25, inch: '15.7 × 9.8 × 9.8 in' },
    { o: 'Medium', L: 43, W: 28, H: 28, inch: '16.9 × 11 × 11 in' },
    { o: 'Large', L: 46, W: 30, H: 30, inch: '18.1 × 11.8 × 11.8 in' }
  ];
  /* Size guide block: [data-pv-sizeguide] containing [data-pv-tabs], [data-pv-draw], tbody[data-pv-spec] */
  PV.sizeGuide = function (el, start, onUse) {
    var S = PV.CARRIER_SIZES, cur = start == null ? 1 : start;
    var tabs = $('[data-pv-tabs]', el), draw = $('[data-pv-draw]', el), spec = $('[data-pv-spec]', el), use = $('[data-pv-use]', el);
    spec.innerHTML = S.map(function (s) { return '<tr><th scope="row">' + s.o + '</th><td>' + s.L + ' × ' + s.W + ' × ' + s.H + ' cm</td><td>' + s.inch + '</td></tr>'; }).join('');
    tabs.innerHTML = S.map(function (s, i) { return '<button role="tab" type="button" data-sz="' + i + '">' + s.o + '</button>'; }).join('');
    function show(i) {
      cur = i; draw.innerHTML = PV.drawCarrier(S[i]);
      $$('button', tabs).forEach(function (b) { var on = +b.dataset.sz === i; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
      $$('tr', spec).forEach(function (tr, j) { tr.classList.toggle('is-on', j === i); });
      if (use) use.textContent = 'Choose ' + S[i].o;
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-sz]'); if (b) show(+b.dataset.sz); });
    tabs.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { show((cur + (e.key === 'ArrowRight' ? 1 : 2)) % 3); $('[data-sz="' + cur + '"]', tabs).focus(); } });
    if (use && onUse) use.addEventListener('click', function () { onUse(S[cur].o); });
    show(cur);
    return { show: show };
  };

  /* ---------- global delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-pv-quick]');
    if (q) { e.preventDefault(); PV.add(q, [{ id: q.dataset.pvQuick, quantity: 1 }], q.dataset.pvLabel); return; }
    var o = e.target.closest('[data-pv-sheet]');
    if (o) { e.preventDefault(); PV.openSheet(o.dataset.pvSheet); return; }
    /* cart drawer recommendations */
    var r = e.target.closest('[data-pv-rec-add]');
    if (r) {
      e.preventDefault();
      var row = r.closest('.pv-rec'), sel = $('select', row), err = $('.pv-err', row);
      var id = sel ? sel.value : r.dataset.pvRecAdd;
      if (!id) { err.textContent = 'Choose an option first.'; sel.focus(); return; }
      err.textContent = '';
      PV.add(r, [{ id: id, quantity: 1 }], r.dataset.pvLabel);
      return;
    }
    if (e.target.closest('[data-pv-recs-off]')) {
      try { sessionStorage.setItem('pv_recs_off', '1'); } catch (x) {}
      document.documentElement.classList.add('pv-recs-off');
    }
  });
  try { if (sessionStorage.getItem('pv_recs_off')) document.documentElement.classList.add('pv-recs-off'); } catch (x) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', PV.delivery); else PV.delivery();
})();
